import InstanceVolumeIopsValue from './InstanceVolumeIopsValue';

export type InstanceVolumeIopsClassProps = {
    aws: any;
    elastx: any;
    lintasarta: any;
    safespring: any;
    syseleven: any;
};

export interface InstanceVolumeIopsInterface {
    aws: any;
    elastx: any;
    lintasarta: any;
    safespring: any;
    syseleven: any;
}

export default class InstanceVolumeIops implements InstanceVolumeIopsInterface {
    readonly aws: any;
    readonly elastx: any;
    readonly lintasarta: any;
    readonly safespring: any;
    readonly syseleven: any;

    constructor(props: InstanceVolumeIopsClassProps) {
        this.aws = props.aws;
        if (this.aws) {
            Object.keys(props.aws).map(
                (k: any) =>
                    (this.aws[`${k}`] = new InstanceVolumeIopsValue(
                        props.aws[k]
                    ))
            );
        } else {
            this.aws = {};
        }

        this.elastx = props.elastx;
        if (this.elastx) {
            Object.keys(props.elastx).map(
                (k: any) =>
                    (this.elastx[`${k}`] = new InstanceVolumeIopsValue(
                        props.elastx[k]
                    ))
            );
        } else {
            this.elastx = {};
        }

        this.lintasarta = props.lintasarta;
        if (this.lintasarta) {
            Object.keys(props.lintasarta).map(
                (k: any) =>
                    (this.lintasarta[`${k}`] = new InstanceVolumeIopsValue(
                        props.lintasarta[k]
                    ))
            );
        } else {
            this.lintasarta = {};
        }

        this.safespring = props.safespring;
        if (this.safespring) {
            Object.keys(props.safespring).map(
                (k: any) =>
                    (this.safespring[`${k}`] = new InstanceVolumeIopsValue(
                        props.safespring[k]
                    ))
            );
        } else {
            this.safespring = {};
        }

        this.syseleven = props.syseleven;
        if (this.syseleven) {
            Object.keys(props.syseleven).map(
                (k: any) =>
                    (this.syseleven[`${k}`] = new InstanceVolumeIopsValue(
                        props.syseleven[k]
                    ))
            );
        } else {
            this.syseleven = {};
        }
    }
}
